import { Aluminium1, Aluminium2, Aluminium3, Aluminium4, Aluminium5, Client1, Client2, Client3, Client4, Client5, Client6, Client7, Client8, Client9, Finishing1, Finishing2, Finishing3, Finishing4, Finishing5, Finishing6, Finishing7, Finishing8, Interior1, Interior2, Interior3, MissionIcon, Portfolio1, Portfolio2, ProjectImg1, ProjectImg2, ProjectImg3, ProjectImg4, ProjectImg5, ProjectImg6, ProjectLogo1, ProjectLogo2, ServiceImg1, ServiceImg2, ServiceImg3, ServiceImg4, ServiceImg5, ServiceImg6, ServiceImg7, ServiceImg8, ServicesIcon1, ServicesIcon2, ServicesIcon3, SmartHome1, SmartHome2, SmartHome3, SmartHome4, SmartHome5, Stats1, Stats2, Stats3, SwimmingPool1, SwimmingPool10, SwimmingPool11, SwimmingPool12, SwimmingPool13, SwimmingPool14, SwimmingPool15, SwimmingPool2, SwimmingPool3, SwimmingPool4, SwimmingPool5, SwimmingPool6, SwimmingPool7, SwimmingPool8, SwimmingPool9, VisionIcon, WhyChooseIcon1, WhyChooseIcon2, WhyChooseIcon3, WhyChooseIcon4, WhyChooseIcon5 } from "../../ui/AllImages"
import { LazyImage } from "../../ui/Elements"

export const VisionMissionList = [
	{
		img: <VisionIcon alt="VisionIcon" />,
		title: 'aboutH4',
		txt: 'aboutT4',
	},
    {
		img: <MissionIcon alt="MissionIcon" />,
		title: 'aboutH5',
		txt: 'aboutT5',
	},

]
export const ServicesList = [
	{
		img: <ServicesIcon1 alt="ServicesIcon" />,
		title: 'servicesTitle1',
		txt: 'servicesText1',
	},
    {
		img: <ServicesIcon2 alt="ServicesIcon" />,
		title: 'servicesTitle2',
		txt: 'servicesText2',
	},
	{
		img: <ServicesIcon3 alt="ServicesIcon" />,
		title: 'servicesTitle3',
		txt: 'servicesText3',
	},
]
export const StatsList = [
	{
		img: <Stats1 alt="ServicesIcon" />,
		number: '750+',
		txt: 'stats1',
	},
    {
		img: <Stats2 alt="ServicesIcon" />,
		number: '7+',
		txt: 'stats2',
	},
	{
		img: <Stats3 alt="ServicesIcon" />,
		number: '5+',
		txt: 'stats3',
	},
]
export const WhyChooseList = [
	{
		img: <WhyChooseIcon1 alt="WhyChooseIcon" />,
		txt: 'deepExperience',
	},
    {
		img: <WhyChooseIcon2 alt="WhyChooseIcon" />,
		txt: 'strategicLocations',
	},
	{
		img: <WhyChooseIcon3 alt="WhyChooseIcon" />,
		txt: 'highStandards',
	},
	{
		img: <WhyChooseIcon4 alt="WhyChooseIcon" />,
		txt: 'trustedPartnerships',
	},
	{
		img: <WhyChooseIcon5 alt="WhyChooseIcon" />,
		txt: 'investmentOpportunities',
	},
]

export const BrandDataConfig = [
    {
        img: <img src={Client1} alt="client" />
    },
    {
        img: <img src={Client2} alt="client" />
    },
    {
        img: <img src={Client3} alt="client" />
    },
    {
        img: <img src={Client4} alt="client" />
    },
    {
        img: <img src={Client5} alt="client" />
    },
    {
        img: <img src={Client3} alt="client" />
    },

]

export const ProjectsDataList = [
  {
    id: 1,
    images: [ProjectImg1, ProjectImg2, ProjectImg3],
	logoimg: <img src={ProjectLogo1} alt="Project main" />,
	number: '01',
	title: 'individualTowers',
	brandName: 'brandName',
	tower: 'alveraTower',
	meaningFirst: 'alveraMeaning',
	alveraDescription: 'alveraDescription',
  },
  {
    id: 2,
    images: [ProjectImg4, ProjectImg5, ProjectImg6],
	logoimg: <img src={ProjectLogo2} alt="Project main" />,
	number: '02',
	title: 'combinedTowers',
	brandName: 'brandName',
	tower: 'nexiusTower',
	meaning: 'nexiusMeaning1',
	meaning1: 'nexiusMeaning1',
	meaning2: 'nexiusMeaning2',
	nexiusDescription1Eng: 'nexiusDescription1Eng',
	nexiusDescription1: 'nexiusDescription1',
	nexiusDescription2: 'nexiusDescription2',
	nexiusDescription3: 'nexiusDescription3',
	nexiusDescription4: 'nexiusDescription4',
  },
  // you can add more projects easily here...
]






















export const ServicesList1 = [
	{
		img: "",
		title: 'SLTitle1',
		txt: 'SLText1',
		listing: [ 
			{
				listTxt: 'SLList1_1',
			},
			{
				listTxt: 'SLList1_2',
			},
			{
				listTxt: 'SLList1_3',
			},
			
        ],
	},
    

]

export const ServicesList2 = [
	{
		img: "",
		title: 'SLTitle2',
		txt: 'SLText2',
		listing: [ 
			{
				listTxt: 'SLList2_1',
			},
			{
				listTxt: 'SLList2_2',
			},
			{
				listTxt: 'SLList2_3',
			},
			
        ],
	},
    

]




export const clientsItems = [
    {
        img: <img className='client-img' src={Client1} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client2} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client3} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client4} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client5} alt="client" />,
    },
	
]

export const FaqsList = [
    {
        question: 'question1',
        answer: "answer1",
    },
    {
        question: 'question2',
        answer: "answer2",
    },
    {
        question: 'question3',
        answer: "answer3",
    },
    {
        question: 'question4',
        answer: "answer4",
    },
    {
        question: 'question5',
        answer: "answer5",
    },

]